import { Component, Vue } from 'vue-property-decorator'
import { QuestionDetail, SetUseful } from '@/types/type'
import { getQuestionDetail, questionSetUseful, questionLoginDetail } from '@/api'
import Header from '@/components/componentWap/Header.vue'
import ActiveComponent from '@/components/ActiveComponent.vue'
@Component({
    name: 'QuestionDetail',
    components: {
        Header,
        ActiveComponent
    }
})
export default class extends Vue {
    private editData: QuestionDetail = new QuestionDetail()
    private questionId = this.$route.query.questionId as string
    private async questionDetail() {
        if (this.questionId) {
            let res: any = {}
            if (this.$isLogin) {
                res = await questionLoginDetail(this.questionId)
            } else {
                res = await getQuestionDetail(this.questionId)
            }
            this.editData = res.data
        }
    }
    // 切换上下篇
    private async changeContent(type: string) {
        if (type === 'pre') {
            if (this.editData.preVO && this.editData.preVO.id) {
                this.questionId = this.editData.preVO.id
            }
        } else {
            if (this.editData.nextVO && this.editData.nextVO.id) {
                this.questionId = this.editData.nextVO.id
            }
        }
        let res: any = {}
        if (this.$isLogin) {
            res = await questionLoginDetail(this.questionId)
        } else {
            res = await getQuestionDetail(this.questionId)
        }
        this.editData = res.data
    }
    // 评价
    private async evaluate(type: number) {
        const params = new SetUseful()
        params.useful = type
        params.id = this.questionId
        await questionSetUseful(params)
        this.editData.useful = type
    }
    async created() {
        this.questionDetail()
    }
}